export enum DoorLocation {
  Center = 'center',
  Multiple = 'multiple',
  None = 'none',
  NotCenter = 'notcenter',
}
